import React from "react";
import ConclusionImage from "../../resources/conclusion_image.png";

const Conclusion = () => {
    return (
    <div className="page__section" id="conclusion">
        <p className="title">Conclusioni</p>
        <hr></hr>
        <div className='conclusion__content'>
        <div className='conclusion__text'>
            <p className='conclusion__text__cell'>
                Siamo così riusciti a realizzare un sistema di efficientamento energetico 
                pronto all'uso e che nel futuro potrà ricevere miglioramenti.
                Siamo pronti a buttarci in nuove avventure e migliorare il nostro prodotto, ma sopratutto...
                <p className='conclusion__important'><i>With us, bE-More.</i></p>
            </p>
        </div>
        <img className='conclusion__image' src={ConclusionImage}></img>
        </div>
    </div>
    );
};


export default Conclusion;